import * as THREE from 'three';

/**
 * The orbit distance a position sync should keep. Starting the page in ortho,
 * drei builds a fresh CameraControls for the `<OrthographicCamera>` (which has
 * no position, so it sits at the origin) around a target at the origin: its
 * orbit radius is 0. The sync then "preserved" that via `dollyTo(0)` →
 * clamped to `minDistance` (EPSILON), which at EOV coordinates rounds to the
 * camera sitting exactly on its target — rotation changes nothing (0.00°,
 * measured) while wheel zoom still works, until a camera switch re-poses it.
 * An orbit camera with no real distance gets the mode's default instead
 * (1000 m ortho, 50 m perspective — see CLAUDE.md); first person orbits at
 * ~0 by design and keeps its 1e-5 offset.
 */
export const orbitDistanceOrDefault = (distance: number, camera: THREE.Camera, orbit: boolean): number => {
  if (!orbit) return distance > 1e-6 ? distance : 1e-5;
  if (distance > 1e-3) return distance;
  return camera instanceof THREE.OrthographicCamera ? 1000 : 50;
};
